import { JsBridge, SendPreferenceCRMData, encodeData } from './js-bridge';
import { handleJsBridgePromise } from './js-bridge-proxy';

export class JsBridgeRN extends JsBridge {
    appShareUrl(url: string): void {
        RNDiscoverJsBridge?.appShareUrl(url);
    }
    appOpenExternalBrowser(url: string): void {
        RNDiscoverJsBridge?.appOpenExternalBrowser(url);
    }
    appSetUiVisibility(ui: 'btnBack' | 'btnCalendar' | 'btnSkip', visable: boolean): void {
        RNDiscoverJsBridge?.appSetUiVisibility(ui, visable);
    }
    appGetLocalStorageDataRequest(): void {
        // console.log('call appGetLocalStorageDataRequest-------RN');
        RNDiscoverJsBridge?.appGetLocalStorageDataRequest();
    }
    appGetLocalStorageDataRequestAsync(): void {
        // console.log('call appGetLocalStorageDataRequestAsync-------RN');
        RNDiscoverJsBridge?.appGetLocalStorageDataRequestAsync();
    }
    appSaveDiscoverPreference(data: SendPreferenceCRMData): void {
        const jsonStringBase64 = encodeData(data);
        RNDiscoverJsBridge?.appSaveDiscoverPreference(jsonStringBase64);
    }
    appOpenRacingLiveStream(): void {
        RNDiscoverJsBridge?.appOpenRacingLiveStream();
    }
    appCloseNativePIP(): void {
        RNDiscoverJsBridge?.closeNativePIP();
    }
    /**
     * True = PIP
     * False = FullScreen
     */
    appOpenNativePlayer(url: string, title: string, isPip: boolean): void {
        RNDiscoverJsBridge?.openNativePlayer(url, title || '', isPip);
    }
    appOpenMsLiveStream(): void {
        RNDiscoverJsBridge?.appOpenMsLiveStream();
    }
    addCalendarEvent(
        title: string,
        description: string,
        eventUUID: string,
        startTime: number,
        endTime: number
    ): Promise<{ eventUUID: string; result: boolean }> {
        return handleJsBridgePromise(() => {
            const result = RNDiscoverJsBridge?.addCalendarEvent(
                title,
                description,
                eventUUID,
                startTime,
                endTime
            );

            // 检查返回值是否为 Promise
            if (result instanceof Promise) {
                return result; // 返回 Promise
            } else {
                return Promise.reject(
                    new Error('RNDiscoverJsBridge.addCalendarEvent is not available.')
                );
            }
        });
    }
    // ):  void {
    //     RNDiscoverJsBridge?.addCalendarEvent(title, description, eventUUID, startTime, endTime);
    // }
    appOnLeavePreferencePage(): void {
        RNDiscoverJsBridge?.onLeavePreferencePage();
    }
}
